import { useMemo } from "react";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";
import { AxnAdminUserOrganizationProperty } from "@idw-types/data/axn-admin-user";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";

type OrganizationPermissionContainerProps = {
    isDisabled: boolean;
    userId: string;
    organizationId: string;
    axnAdminAvailableUserOrganizationProperty: AxnAdminAvailableUserProperty;
    axnAdminUserOrganizationProperties: Array<AxnAdminUserOrganizationProperty>;
    addOrganizationProperties: (
        orgProperties: Array<AxnAdminUserOrganizationProperty
        >
    ) => void;
    removeOrganizationProperties: (
        orgProperties: Array<AxnAdminUserOrganizationProperty>
    ) => void;
};

export const OrganizationPermissionContainer = (props: OrganizationPermissionContainerProps) => {
    const {
        addOrganizationProperties,
        axnAdminAvailableUserOrganizationProperty,
        axnAdminUserOrganizationProperties,
        isDisabled,
        organizationId,
        removeOrganizationProperties,
        userId
    } = props;

    const property = useMemo(() => {
        return axnAdminUserOrganizationProperties.find(orgProperty => orgProperty.propertyName === axnAdminAvailableUserOrganizationProperty.shortName);
    }, [axnAdminAvailableUserOrganizationProperty, axnAdminUserOrganizationProperties]);

    const propertyIsTrue = useMemo(() => {
        return !!property && isStringTrue(property.propertyValue);
    }, [property]);

    const onChangePropertyValue = () => {
        if (propertyIsTrue) {
            removeOrganizationProperties([property]);
        } else {
            addOrganizationProperties([{
                id: null,
                propertyName: axnAdminAvailableUserOrganizationProperty.shortName,
                propertyValue: "true",
                organizationID: organizationId,
                userID: userId
            }]);
        }
    };



    return (
        <ToggleFormGroup
            labelWidth={LabelWidthTypes.LARGE}
            checked={propertyIsTrue}
            controlId={`org-${organizationId}-property-${axnAdminAvailableUserOrganizationProperty.shortName}`}
            disabled={isDisabled}
            isRequired={false}
            label={axnAdminAvailableUserOrganizationProperty.name}
            value={`${propertyIsTrue}`}
            onChange={onChangePropertyValue}
            afterLabelTooltipText={axnAdminAvailableUserOrganizationProperty.description}  
        />
    );
};